import { usePathname } from 'hooks/usePathname/usePathname';
import { useGetSignupState } from 'lendingApi/lendingApiHooks';
import { TSignupSteps } from 'types';
import { useSignupData } from './useSignupData';

export const STEPS: TSignupSteps[] = [
  'new',
  'new/productOffers',
  'new/documents',
];

export function useSignupStep() {
  const pathname = usePathname();
  const { updateLatestSignupStep } = useSignupData();
  const { state, refetchState, stateFetching } = useGetSignupState();

  const currentStep = pathname.replace('/application/', '');
  const latestStepAllowed = state?.ui?.tip_latest_signup_step;

  const latestStepAllowedIndex = STEPS.findIndex(
    (step) => step === latestStepAllowed,
  );

  const updateLatestAllowedStep = async (
    newStep: TSignupSteps,
    updatedState = state,
  ) => {
    if (!updatedState) {
      throw new Error('Error updating latest step');
    }

    const newStepIndex = STEPS.findIndex((step) => step === newStep);
    if (newStepIndex > latestStepAllowedIndex) {
      await updateLatestSignupStep(newStep, updatedState);
    }
  };

  return {
    state,
    stateFetching,
    currentStep,
    latestStepAllowed,
    refetchState,
    updateLatestAllowedStep,
  };
}
